import { ShoesState } from 'src/types'
import { darkenColor } from 'src/util/color'

const lace = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number) => {
  if (!ctx) return
  // lace
  ctx.beginPath()
  ctx.fillStyle = state.vampStrap.color
  ctx.lineWidth = 1.0
  ctx.moveTo(374 + x, 285 + y)
  ctx.quadraticCurveTo(384 + x, 285 + y, 394 + x, 295 + y)
  ctx.quadraticCurveTo(407 + x, 301 + y, 410 + x, 289 + y)
  ctx.quadraticCurveTo(405 + x, 276 + y, 393 + x, 273 + y)
  ctx.quadraticCurveTo(375 + x, 274 + y, 374 + x, 285 + y)
  ctx.fill()
  ctx.moveTo(374 + x, 284 + y)
  ctx.quadraticCurveTo(389 + x, 281 + y, 397 + x, 295 + y)
  ctx.stroke()
  ctx.closePath()
}

const lace2 = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  if (!ctx) return
  // lace
  ctx.beginPath()
  ctx.fillStyle = state.vampStrap.color
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  ctx.moveTo(241, 325)
  ctx.quadraticCurveTo(232, 334, 239, 342)
  ctx.quadraticCurveTo(249, 344, 254, 337)
  ctx.quadraticCurveTo(253, 322, 265, 324)
  ctx.quadraticCurveTo(265, 321, 265, 321)
  ctx.quadraticCurveTo(256, 317, 241, 325)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.moveTo(257, 320)
  ctx.quadraticCurveTo(244, 329, 251, 339)
  ctx.stroke()
  ctx.closePath()
}

const laceHole = (ctx: CanvasRenderingContext2D | null, x: number, y: number): void => {
  if (!ctx) return
  ctx.beginPath()
  ctx.arc(x, y, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const fielderToeGuard = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return

  ctx.lineWidth = 1.0
  const fillTipColor = darkenColor(state.toeGuardColor.color, 0.3)
  ctx.fillStyle = fillTipColor //'#a8a797'
  ctx.beginPath()
  ctx.moveTo(14, 433)
  ctx.quadraticCurveTo(87, 477, 175, 495)
  ctx.quadraticCurveTo(155, 383, 140, 330)
  ctx.quadraticCurveTo(115, 325, 75, 345)
  ctx.quadraticCurveTo(7, 380, 14, 433)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(136, 332)
  ctx.quadraticCurveTo(155, 403, 169, 491)
  ctx.moveTo(132, 332)
  ctx.quadraticCurveTo(151, 403, 165, 491)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
  ctx.lineWidth = 1.0
}

const pitcherToeGuard = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  const fillColor = state.toeGuardColor.color

  ctx.fillStyle = fillColor //'#E6E4CD'
  ctx.beginPath()
  ctx.moveTo(14, 433)
  ctx.quadraticCurveTo(87, 473, 165, 492)
  ctx.quadraticCurveTo(269, 517, 355, 503)
  ctx.quadraticCurveTo(357, 500, 365, 471)
  ctx.quadraticCurveTo(380, 382, 409, 347)
  ctx.quadraticCurveTo(446, 305, 426, 258)
  ctx.quadraticCurveTo(274, 328, 213, 328)
  ctx.quadraticCurveTo(115, 325, 75, 345)
  ctx.quadraticCurveTo(7, 380, 14, 433)
  //   ctx.quadraticCurveTo(
  //   ctx.quadraticCurveTo(
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(313, 313)
  ctx.quadraticCurveTo(425, 266, 425, 266)
  ctx.quadraticCurveTo(428, 281, 428, 281)

  ctx.moveTo(218, 330)
  ctx.quadraticCurveTo(215, 372, 277, 358)
  ctx.quadraticCurveTo(325, 337, 424, 308)
  ctx.quadraticCurveTo(424, 322, 398, 355)
  ctx.quadraticCurveTo(385, 374, 373, 416)
  ctx.quadraticCurveTo(367, 438, 361, 473)
  ctx.quadraticCurveTo(352, 502, 352, 502)

  ctx.moveTo(215, 326)
  ctx.quadraticCurveTo(210, 378, 277, 363)
  ctx.quadraticCurveTo(312, 350, 417, 315)
  ctx.quadraticCurveTo(421, 317, 390, 359)
  ctx.quadraticCurveTo(378, 378, 367, 420)
  ctx.quadraticCurveTo(362, 442, 356, 477)
  ctx.quadraticCurveTo(346, 506, 347, 506)

  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
  ctx.lineWidth = 1.0

  ctx.lineWidth = 1.0
  const fillTipColor = darkenColor(state.toeGuardColor.color, 0.3)
  ctx.fillStyle = fillTipColor //'#a8a797'
  ctx.beginPath()
  ctx.moveTo(14, 433)
  ctx.quadraticCurveTo(87, 473, 165, 492)
  ctx.quadraticCurveTo(269, 517, 355, 503)
  ctx.quadraticCurveTo(208, 365, 135, 329)
  ctx.quadraticCurveTo(115, 325, 75, 345)
  ctx.quadraticCurveTo(7, 380, 14, 433)

  //   ctx.quadraticCurveTo(
  //   ctx.stroke()
  ctx.fill()
  ctx.closePath()

  if (state.vampStrapType.value === 'laceType') {
    laceHole(ctx, 244, 338)
    laceHole(ctx, 302, 327)
    laceHole(ctx, 353, 309)
    laceHole(ctx, 402, 290)

    lace(ctx, state, -100, 37)
    lace(ctx, state, -50, 19)
    lace(ctx, state, 0, 0)
    lace(ctx, state, 52, -28)
    lace(ctx, state, 98, -55)
    lace2(ctx, state)
  }
}

const metalEdge = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.beginPath()
  ctx.fillStyle = '#383838'
  ctx.strokeStyle = '#383838'
  ctx.moveTo(11, 431)
  ctx.quadraticCurveTo(50, 455, 104, 473)
  ctx.quadraticCurveTo(108, 483, 99, 486)
  ctx.quadraticCurveTo(38, 463, 5, 443)
  ctx.quadraticCurveTo(3, 428, 11, 431)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const toeGuard = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (state.toeGuard.value === 'none') return

  const toeGuardKind = state.toeGuardKind.value
  if (['forPitcher', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    pitcherToeGuard(ctx, state)
  }

  if (['forFielder', 'forFielderWithMetalReinforcement'].includes(toeGuardKind)) {
    fielderToeGuard(ctx, state)
  }

  if (['forFielderWithMetalReinforcement', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    metalEdge(ctx, state)
  }
}
